import { Button, ButtonGroup, base } from "@adfenix/alexandria";
import { Col, Container, Row } from "react-grid-system";

import UilExchange from "@iconscout/react-unicons/icons/uil-exchange";
import { selectHqOfficeModalState } from "atoms/selectedHqHoc";
import styled from "styled-components";
import { useOfficeAndHq } from "hooks/useOfficeAndHq";
import { useSetRecoilState } from "recoil";

const StyledRow = styled(Row)`
  color: ${({ theme }) => base(theme.colors.grey)};
  font-weight: 600;
`;

const BoldedRow = styled(Row)`
  font-weight: 600;

  ${({ theme }) => theme.fonts.m};
`;

export const SelectHqAndOfficeSwitch = () => {
  const { hq, office } = useOfficeAndHq();

  const setModalOpen = useSetRecoilState(selectHqOfficeModalState);

  return (
    <ButtonGroup>
      <Container>
        <Row>
          <Col>
            <StyledRow>HEADQUARTER</StyledRow>
            <BoldedRow>{hq?.name}</BoldedRow>
          </Col>

          {office && (
            <>
              <Col width={8} />

              <Col>
                <StyledRow>OFFICE</StyledRow>
                <BoldedRow>{office?.name}</BoldedRow>
              </Col>
            </>
          )}
        </Row>
      </Container>
      <Button
        logLabel="open-hq-select-button"
        variant="secondary"
        style={{ alignSelf: "center" }}
        onClick={() => {
          setModalOpen(true);
        }}
      >
        {<UilExchange size="20" style={{ verticalAlign: "text-bottom" }} />}
      </Button>
    </ButtonGroup>
  );
};
